import { FC, Suspense, lazy } from 'react';
import { useClientState } from 'dibs-react-hooks/exports/useClientState';
// components
import { FormattedMessage } from 'dibs-react-intl';

// styles
import styles from './PdpSharedAuctionUnavailable.scss';

const UnavailableIcon = lazy(
    () => import(/* webpackChunkName: "UnavilableIcon" */ 'dibs-icons/exports/Unavailable')
);

export const PdpSharedAuctionUnavailable: FC = () => {
    const isClient = useClientState();
    return (
        <div className={styles.container}>
            <span className={styles.closed}>
                <FormattedMessage
                    id="PdpSharedAuctionUnavailable.biddingClosed"
                    defaultMessage="Bidding Closed"
                />
            </span>
            <span className={styles.unavailable}>
                {isClient && (
                    <Suspense fallback={null}>
                        <UnavailableIcon className={styles.icon} />
                    </Suspense>
                )}
            </span>
        </div>
    );
};
